
export default {
    namespaced: true,
    state: {
        sitesData: [],
        currentPage: 1,
        totalRows: null,
        perPage: 30,
        params: {
            groupFilter: null,
            search: null,
            sort: {
                dir: 'asc',
                field: 'domain'
            }
        },
        groups: [],
        currentGroup: false,
        haveEmptyResponse: false
    },
    getters: {
        GROUPS: state => {
            return state.groups;
        },
        PER_PAGE: state => {
            return state.perPage;
        },
        HAVE_EMPTY_RESPONSE: state => {
            return state.haveEmptyResponse;
        },
        CURRENT_GROUP1: state => {
            return state.currentGroup;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        PARAMS: state => {
            return state.params;
        },
        SITES_DATA: state => {
            return state.sitesData;
        },
        GET_PREPARE_PARAMS: state => {
            return {
                'page': state.currentPage,
                'pageSize': state.perPage <= 0 ? 1 : state.perPage,
            }
        },
    },
    mutations: {

        GROUPS: (state, payload) => {
            return state.groups = payload;
        },
        PER_PAGE: (state, payload) => {
            return state.perPage = payload;
        },
        CURRENT_GROUP: (state, payload) => {
            return state.currentGroup = payload;
        },
        PARAMS: (state, payload) => {
            return state.params = payload;
        },
        SITES_DATA: (state, payload) => {
            return state.sitesData = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        },
        HAVE_EMPTY_RESPONSE: (state, payload) => {
            return state.haveEmptyResponse = payload;
        },
    },
    actions: {
        GET_DATA: async ({getters, state, commit}, payload) => {
            let params = getters.GET_PREPARE_PARAMS;
            params = JSON.stringify(params);
            payload.th.showBottomOverlay ++;
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/sites-by-group?params='+ params,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    // prepare value
                    for (let key in responseData.data) {
                        let val = responseData.data[key]
                        if (val == undefined || val == null)
                            continue
                        state.sitesData.push(val)
                    }

                    // for the first time
                    if (state.perPage != 1) {
                        // next load by 10 item
                        state.perPage = 1
                        state.currentPage = 2
                    }
                    if (responseData.data.length > 0) {
                        state.currentPage ++
                    } else {
                        commit('HAVE_EMPTY_RESPONSE', true);
                    }

                    commit('SITES_DATA', state.sitesData);
                },
                getResponse: () => {
                    payload.th.showBottomOverlay --;
                    payload.th.showOverlay --;
                },
            });
        },
    }
}